export default "__VITE_ASSET__THGbQxG$__"